import type {
  ScoutChatMessage as StoredScoutChatMessage,
  ScoutFilePart,
  ScoutMessagePart as ScoutChatMessagePart,
  ScoutTextPart,
  ScoutToolPart,
  ScoutToolState,
} from "../../hooks/types";

import { stripProviderCitationArtifacts } from "../../textSanitization";

export type { ScoutChatMessagePart, ScoutFilePart, ScoutTextPart, ScoutToolPart, ScoutToolState };

export type ScoutChatMessage = Omit<StoredScoutChatMessage, "content" | "parts"> & {
  content?: string;
  parts: ScoutChatMessagePart[];
};

const TERMINAL_ERROR_PART_ID_PREFIX = "terminal-error-";

export function isTerminalScoutErrorPart(part: ScoutChatMessagePart): boolean {
  return (
    part.type === "text" &&
    part.agentState === "error" &&
    part.id.startsWith(TERMINAL_ERROR_PART_ID_PREFIX)
  );
}

export function getScoutTerminalError(message: ScoutChatMessage): string | undefined {
  const terminalErrorPart = message.parts.find(
    (part): part is ScoutTextPart => part.type === "text" && isTerminalScoutErrorPart(part)
  );
  const error = terminalErrorPart?.text.trim();
  return error ? error : undefined;
}

export function getScoutMessageTextParts(parts: ScoutChatMessagePart[]): string[] {
  return parts.flatMap((part) => {
    if (part.type !== "text" || isTerminalScoutErrorPart(part)) {
      return [];
    }

    const text = stripProviderCitationArtifacts(part.text).trim();
    return text ? [text] : [];
  });
}

export function getScoutMessageText(message: ScoutChatMessage): string {
  return getScoutMessageTextParts(message.parts).join("\n\n");
}
